var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yesno",class:{
    yesno_clearable: _vm.clearable,
    yesno_vertical: _vm.vertical,
    'yesno_fit-content': _vm.fitContent
  }},_vm._l((_vm.finalOptions),function(option){return _c('span',{key:option.value,staticClass:"yesno__option",class:{ yesno__option_active: _vm.value == option.value },on:{"click":function($event){return _vm.onClick(option.value)}}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }